import type { FC } from 'react'

import type { IBookingOverlayProps } from 'features/Booking/interfaces/ILeaseOverlayProps'
import { LeaseContent } from 'features/Booking/components/LeaseContent/LeaseContent'

const Lease: FC<IBookingOverlayProps> = (props) => <LeaseContent {...props} />

export default Lease
